import { publicApi } from "@/lib/axios/instances";
import { FavoriteItem, Favorites } from "@/types/favorites";
import { Product } from "@/types/product";

export const fetchFavorites = async (): Promise<Favorites> => {
  const response = await publicApi.get("/favorites");
  return response.data;
};

export const addToFavorites = async (dto: { productId?: FavoriteItem['productId'], giftBoxId?: FavoriteItem['giftBoxId'] }): Promise<FavoriteItem> => {
  const response = await publicApi.post("/favorites", dto);
  return response.data;
};

export const removeFromFavorites = async (id: FavoriteItem['id']) => {
  const response = await publicApi.delete(`/favorites/${id}`);
  return response.data;
};
